import { render, staticRenderFns } from "./ElemLabel.vue?vue&type=template&id=18d5f5c2&"
import script from "./ElemLabel.vue?vue&type=script&lang=js&"
export * from "./ElemLabel.vue?vue&type=script&lang=js&"
import style0 from "./ElemLabel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports